

<footer id="footer" class="footer light-background py-1">

  <div class="container footer-top">
    <div class="row gy-4">
      <div class="col-lg-4 col-md-6 footer-about text-center">
        <a class="navbar-brand" routerLink="/">
          <img ngSrc="assets/img/mediLinkWhite.svg"  alt="Logo" width="200" height="75"  class="d-inline-block align-text-top">
        </a>
        <div class="container text-center my-2">
          <p class="fw-bolder fs-5">&#64;GrupoMedilink</p>
        </div>
        <div class="  social-links d-flex mt-4 justify-content-center ">
          <a href="https://www.youtube.com/c/MediLinkEcuador" target="_blank"><i class="bi bi-youtube fs-4"></i></a>
          <a href="https://www.facebook.com/GrupoMediLink" target="_blank"><i class="bi bi-facebook fs-4"></i></a>
          <a href="https://www.instagram.com/grupomedilink/" target="_blank"><i class="bi bi-instagram fs-4"></i></a>
          <a href="https://www.linkedin.com/company/medilink-s-a/" target="_blank"><i class="bi bi-linkedin fs-4"></i></a>
        </div>

        <div class="px-5 py-3 text-lg-start">
          <ul>
            <li class="fs-6  fw-normal"><a class="text-light" routerLink="/nosotros">Nosotros</a></li>
<!--            <li class="fs-6  fw-normal"><a class="text-light" href="">Preguntas Frecuentes</a></li>-->
<!--            <li class="fs-6  fw-normal"><a class="text-light" href="">Términos y Condiciones</a></li>-->
            <li class="fs-6  fw-normal"><a class="text-light" routerLink="/politica-privacidad">Política de privacidad</a></li>
            <li class="fs-6  fw-normal"><a class=" text-light" href="https://sam.medilink.com.ec/sam/login.jsf">SAM</a> <i class="bi  bi-arrow-up-right"></i></li>
            <li class="fs-6  fw-normal"><a class=" text-light" href="https://sio2.medilink.com.ec:8443/sio/login.jsf">SIO</a><i class="bi  bolder bi-arrow-up-right"></i></li>
            <li class="fs-6  fw-normal"><a class=" text-light" href="https://sam.medilink.com.ec/sisweb/">SISWEB</a><i class="bi  bolder bi-arrow-up-right"></i></li>
          </ul>
        </div>

      </div>



      <div class="col mb-lg-3-3 footer-links" *ngFor="let ciudad of sucursalesAgrupadas | keyvalue : customSort">
        <h4 class="fw-bolder fs-6"><i class="bi bi-geo-alt-fill text-light"></i> {{ ciudad.key }} </h4>
        <ul  class="ms-3 pt-2 " *ngFor="let sucursal of ciudad.value" >
          <li class="fw-bolder ">{{sucursal.nameSucursal}}</li>
          <li  class=""><a [href]="sucursal.linkMaps" target="_blank">{{ sucursal.direccionSucursal }}</a></li>
        </ul>
      </div>



    </div>
  </div>

  <div class="container copyright text-center mt-4 mb-5">
    <p>© <span>Copyright</span> <strong class="px-1 sitename">Medilink</strong>
      <span>Todos Los Derechos Reservados</span></p>
  </div>

</footer>
